module.exports = __webpack_public_path__ + "static/media/spade.2e81f0a8.svg";